import React from "react";
import { Avatar, Box, Paper } from "@mui/material";
import { useIntl } from "react-intl";
import RevaText from "components/common/RevaText";
import { resolveBrandingImageUrl } from "components/pages/Gestion/branding/branding-helpers";

/**
 * Lock-screen style preview of a broadcast. Purely presentational.
 * Props: { appName: string, appImage: object|string|null, title: string, body: string }
 */
const PushBroadcastPhonePreview = ({ appName, appImage, title, body }) => {
  const intl = useIntl();
  const cleanTitle = String(title ?? "").trim();
  const cleanBody = String(body ?? "").trim();
  const name = appName || "";

  return (
    <Box data-testid="push-preview">
      <RevaText variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
        {intl.formatMessage({ id: "gestion.push.preview.title" })}
      </RevaText>
      <Box
        sx={{
          width: 300,
          maxWidth: "100%",
          borderRadius: 6,
          border: "8px solid",
          borderColor: "grey.900",
          bgcolor: "grey.800",
          p: 2,
          minHeight: 220,
        }}
      >
        <Paper elevation={0} sx={{ borderRadius: 3, p: 1.5, bgcolor: "rgba(255,255,255,0.92)" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
            <Avatar
              variant="rounded"
              src={resolveBrandingImageUrl(appImage) || undefined}
              sx={{ width: 20, height: 20, fontSize: 12 }}
            >
              {name.trim().charAt(0).toUpperCase()}
            </Avatar>
            <RevaText
              variant="caption"
              data-testid="push-preview-app"
              sx={{ textTransform: "uppercase", flexGrow: 1, color: "text.secondary" }}
            >
              {name}
            </RevaText>
            <RevaText variant="caption" color="text.secondary">
              {intl.formatMessage({ id: "gestion.push.preview.now" })}
            </RevaText>
          </Box>
          <RevaText
            variant="body2"
            data-testid="push-preview-title"
            sx={{ fontWeight: 700, wordBreak: "break-word", ...(cleanTitle ? {} : { color: "text.secondary" }) }}
          >
            {cleanTitle || intl.formatMessage({ id: "gestion.push.preview.titlePlaceholder" })}
          </RevaText>
          <RevaText
            variant="body2"
            data-testid="push-preview-body"
            sx={{
              whiteSpace: "pre-line",
              wordBreak: "break-word",
              display: "-webkit-box",
              WebkitLineClamp: 4,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              ...(cleanBody ? {} : { color: "text.secondary" }),
            }}
          >
            {cleanBody || intl.formatMessage({ id: "gestion.push.preview.bodyPlaceholder" })}
          </RevaText>
        </Paper>
      </Box>
      <RevaText variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
        {intl.formatMessage({ id: "gestion.push.preview.note" })}
      </RevaText>
    </Box>
  );
};

export default PushBroadcastPhonePreview;
